import * as R from 'ramda'

/**
 * This function remove the query parameters(queriesToOmit) from browser url
 *
 * Note: this function must be called with a vue component context because it needs to access this.$router
 * @param queriesToOmit
 */
export default function(queriesToOmit) {
  let { name, query, params } = this.$route
  query = R.omit(queriesToOmit, query)
  this.$router.replace({ name, query, params })
}
